<div class="flex justify-between items-start gap-2" style="height: 25px">
  <div class="text-sm">Status</div>
  @if (isSaving) {
    <div class="spinner-wrapper">
      <p-progress-spinner
        strokeWidth="4"
        fill="transparent"
        animationDuration=".5s"
        [style]="{ width: '20px', height: '20px' }"
      />
    </div>
  } @else if (showCheckIcon()) {
    <i
      class="pi pi-check-circle check-icon"
      [class.fade-out]="checkIconFading()"
      style="color: var(--p-primary-color)"
    ></i>
  }
</div>
<p-select
  class="w-full sm:w-56 bg-transparent text-(--p-text-600) focus:outline-none focus:ring-0 shadow-none"
  [options]="statusOptions()"
  optionLabel="label"
  optionValue="value"
  [loading]="isLoading()"
  [placeholder]="placeholder"
  [disabled]="disabled"
  appendTo="body"
  size="small"
  [ngStyle]="{
    '--p-select-border-color': 'var(--color-surface-switch-300)',
    '--p-select-focus-ring-shadow': 'none',
    '--p-select-focus-ring-width': '0px',
    'box-shadow': 'none',
  }"
  [ngModel]="selectedStatus"
  (ngModelChange)="onStatusChange($event)"
></p-select>
